const cards = [
  {
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20scene%20with%20dramatic%20golden%20hour%20lighting%2C%20film%20noir%20aesthetic%2C%20warm%20amber%20and%20deep%20shadow%20contrast%2C%20classic%20cinema%20composition%2C%20vintage%20movie%20poster%20style%2C%20rich%20textures%20and%20atmospheric%20mood&width=700&height=480&seq=card-bajie-01&orientation=landscape',
    tag: '本周热播',
    title: '最新院线大片抢先看',
    desc: '汇集近期国内外热门院线电影，高清画质同步更新，在家也能享受影院级观影体验。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20style%20romantic%20scene%20with%20soft%20warm%20lighting%2C%20emotional%20atmosphere%2C%20cherry%20blossom%20elements%2C%20gentle%20color%20palette%2C%20cinematic%20composition%2C%20dreamy%20bokeh%20background%2C%20elegant%20minimal%20aesthetic&width=700&height=480&seq=card-bajie-02&orientation=landscape',
    tag: '高分推荐',
    title: '豆瓣8.5+高分韩剧合集',
    desc: '精选口碑爆棚的韩剧作品，从浪漫爱情到悬疑烧脑，部部精彩不容错过。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20art%20style%20dynamic%20action%20scene%2C%20vibrant%20colors%20with%20warm%20sunset%20tones%2C%20sakura%20petals%20floating%2C%20emotional%20character%20moment%2C%20cinematic%20animation%20quality%2C%20dreamy%20atmosphere&width=700&height=480&seq=card-bajie-03&orientation=landscape',
    tag: '追番必备',
    title: '2026夏季新番动画大全',
    desc: '本季最受期待的新番动画一网打尽，热血、治愈、搞笑类型全覆盖。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%20with%20ancient%20palace%20architecture%2C%20warm%20lantern%20light%2C%20traditional%20Chinese%20costume%20aesthetic%2C%20elegant%20composition%2C%20cinematic%20lighting%20with%20golden%20accents%2C%20rich%20cultural%20atmosphere&width=700&height=480&seq=card-bajie-04&orientation=landscape',
    tag: '国剧精选',
    title: '口碑国产剧每日连播',
    desc: '古装权谋、都市情感、年代传奇，国产好剧不断档，每日更新追不停。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Variety%20show%20studio%20set%20with%20colorful%20stage%20lighting%2C%20energetic%20atmosphere%2C%20warm%20spotlights%2C%20entertainment%20production%20vibe%2C%20dynamic%20composition%2C%20professional%20broadcast%20aesthetic%2C%20vibrant%20and%20lively%20mood&width=700&height=480&seq=card-bajie-05&orientation=landscape',
    tag: '综艺热榜',
    title: '热门综艺爆笑合集',
    desc: '旅行、竞技、音乐、脱口秀，各类热门综艺任你选择，周末放松最佳伴侣。',
  },
];

export default function Cards() {
  const handleImgError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    img.style.display = 'none';
  };

  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2 text-center">
          精选推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">编辑精选，为你推荐最值得看的影视内容</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((c, i) => (
            <article
              key={i}
              className={`group rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden hover:-translate-y-1 transition-all ${
                i === 3 ? 'lg:col-span-1' : ''
              } ${i === 4 ? 'sm:col-span-2 lg:col-span-1' : ''}`}
            >
              <div className="relative w-full h-48 overflow-hidden bg-background-200">
                <img
                  src={c.img}
                  alt={c.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="700"
                  height="480"
                  onError={handleImgError}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-semibold bg-primary-500 text-background-50 whitespace-nowrap">
                  {c.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{c.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}